import { toast } from 'react-toastify';

export const toastAction = {
  success: (data: string) => {
    if (data) {
      toast.success(data, { autoClose: 2000 });
    }
  },
  error: (error: any) => {
    if (error?.networkError?.result?.errors[0]?.message) {
      toast.error(error.networkError.result.errors[0].message);
    } else if (error) {
      toast.error(error);
    } else {
      toast.error('server error', { autoClose: 2000 });
    }
  },
};

export const toastEmitter = (text: string) => {
  toast.info(text, {
    position: 'bottom-right',
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
  });
};
